type ResetPasswordResponse = {
    success: boolean;
    message: string;
};

export const resetPassword = async (password: string, token: string): Promise<ResetPasswordResponse> => {
    try {
        const res = await fetch("/api/password", {
            method: "PATCH",
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ password }),
        });

        const data = await res.json();

        if (res.ok) {
            return { success: true, message: "Contraseña restablecida con éxito. Ahora puedes iniciar sesión." };
        } else {
            return { success: false, message: data.error || "Ocurrió un error." };
        }
    } catch (error) {
        return { success: false, message: "Error al restablecer la contraseña." };
    }
};

export default resetPassword;

